import { FIleUpload } from "../../lib/interfaces/IFileUploadInterface";
import { apiContext } from "../../lib/config/EncryptAPIContext";

type XlsxCallback = (
  json: FIleUpload[],
  respCode: number,
  respMsg: string,
  totalPrincipal?: number,
  batchNumber?: string,
  fileSource?: string,
  fileVersion?: string
) => void;

export const xlsxConvertToJSON = async (
  file: File,
  fileExtension: string,
  callback: XlsxCallback,
  errorCallback: (error: string) => void,
  partnerName?: string
): Promise<void> => {
  const formData = new FormData();
  const isTxtFile = fileExtension.toLowerCase() === "txt";
  const fileType = isTxtFile ? "txt" : "Dynamic";

  formData.append("file", file);
  formData.append("type", fileType);
  if (partnerName !== undefined) {
    formData.append("partnerName", partnerName);
  }
  try {
    const response = await apiContext.post("/Xlxs", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    const { status, data } = response;
    if (status !== 200 || data.respCode !== 2000) {
      errorCallback(data?.respMsg ?? "Unknown server error");
      return;
    }

    const {
      list: json,
      respCode,
      respMsg,
      totalPrincipal,
      batchNumber,
      fileSource,
      fileVersion,
    } = data;

    callback(
      json,
      respCode,
      respMsg,
      totalPrincipal,
      batchNumber,
      fileSource,
      fileVersion
    );
  } catch (error: any) {
    errorCallback(error?.message ?? "Unexpected error occurred");
  }
};
